/** @jsx jsx */
import { jsx } from '@emotion/core'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

import { MarcosDesenvolvimentoModel } from '../marcos/MarcosDesenvolvimentoView'
import { ReflexosNeuroAlert } from '../marcos/ReflexosNeuroAlert'
import { PuericulturaModel } from '../PuericulturaView'

interface PeuriculturaAlertProps {
  name: MetaPath<PuericulturaModel>
}

export function PeuriculturaAlert(props: PeuriculturaAlertProps) {
  const { name } = props

  const {
    input: { value },
  } = useField<MarcosDesenvolvimentoModel>(name.marcosDesenvolvimento.absolutePath())

  if (!value) return null

  return <ReflexosNeuroAlert reflexosNeuroList={value.marcoDesenvolvimento} />
}
